import React, { useEffect } from "react";
import styled from "styled-components";
import { Button } from "@onelogin/react-components";
// this component houses the OneTrust cookie settings button.
// any potential future styling of this button should go here

const StyledButton = styled(Button)`
  // !important tags are necessary to override OneTrust button styling
  color: rgb(88, 89, 89) !important; 
  border: 1px solid rgb(212, 214, 214) !important; 
  height: 38px !important; 
  padding: 0px 16px !important; 
  font-size: 14px !important; 
  line-height: 16px !important;

  &:hover {
    color: rgb(8, 145, 191) !important; 
    background-color: rgba(0, 0, 0, 0.05) !important; 
  }
`;

const CookieSettingsButton = props => {

  useEffect(() => {
    if (window?.OneTrust?.initializeCookiePolicyHtml) {
      window.OneTrust.initializeCookiePolicyHtml(); 
    }; 
  }, []); 

  return (
    <StyledButton id="ot-sdk-btn" look="regular" className="ot-sdk-show-settings">
      Cookie Settings
    </StyledButton>
  );
};

export default CookieSettingsButton;
